import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ApiSuccess,
  OpenAiImageProviderSettingInput,
  OpenAiImageProviderSettingView,
  OpenAiImageProviderTestResult,
} from '@app/shared';
import { apiClient } from '../../lib/api-client';

const KEY = ['settings', 'openai-image-provider'];

export function useOpenAiImageProviderSetting() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<OpenAiImageProviderSettingView> => {
      const res = await apiClient.get<ApiSuccess<OpenAiImageProviderSettingView>>(
        '/settings/openai-image-provider',
      );
      return res.data.data;
    },
  });
}

export function useUpdateOpenAiImageProvider() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (
      input: OpenAiImageProviderSettingInput,
    ): Promise<OpenAiImageProviderSettingView> => {
      const res = await apiClient.put<ApiSuccess<OpenAiImageProviderSettingView>>(
        '/settings/openai-image-provider',
        input,
      );
      return res.data.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function useTestOpenAiImageProvider() {
  return useMutation({
    mutationFn: async (): Promise<OpenAiImageProviderTestResult> => {
      const res = await apiClient.post<ApiSuccess<OpenAiImageProviderTestResult>>(
        '/settings/openai-image-provider/test',
      );
      return res.data.data;
    },
  });
}
